<div class="h-screen w-screen flex items-center justify-center">
  <span class="text-3xl font-semibold p-6 text-black">{{
    "common.welcome-to-system-voucher" | translate | sentenceCase
  }}</span>
</div>
